export default __webpack_public_path__ + "static/media/p4-12.4bfc9b26.png";